(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AddCategoryModalCtrl", ["examCategoryResource", "$localStorage", "$rootScope", "$scope", "$state", "_", "messageService", addCategoryModalCtrl]);
    function addCategoryModalCtrl(examCategoryResource, $localStorage, $rootScope, $scope, $state, _, messageService) {
        var vm = this;
        vm.number = $state.params.number;
        vm.saving = false;
        vm.state = "showForm";
        vm.formData = {
            name: "",
            randomQuestions: null,
            isRandomized: false,
            enabled: true
        };
        examCategoryResource.getExamCategoryViewModel({ number: vm.number }, function (model) {
            vm.exam = model.examNumber + " - " + model.examName;
            vm.formData.examId = model.examId;
        });
        vm.createExamCategory = function () {
            if (vm.form.$valid) {
                if (vm.saving)
                    return;
                vm.saving = true;
                examCategoryResource.save({ number: vm.number }, vm.formData, function (result) {
                    vm.categoryNumber = result.examCategoryNumber;
                    vm.examId = result.examId;
                    vm.state = "showConfirmation";
                    $rootScope.$broadcast("reloadCategories");
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        //Clears form to be able to add another
        vm.createAnother = function () {
            vm.saving = false;
            vm.formData = {
                name: "",
                randomQuestions: null,
                isRandomized: false,
                enabled: true,
                examId: vm.examId
            };
            vm.number = $state.params.number;
            vm.state = "showForm";
            vm.showErrors = false;
        };
    }
}());
